import { ActionContext } from "vuex";
import { ISettingsState } from "./types";
import { TokenStorage } from "@/utils/tokenStorage";
import UserInterface from "@/types/app/IUser";

export default {
  setUser(store: ActionContext<ISettingsState, any>, user: object): void {
    store.commit("setUser", user);
  },
  setUsers(store: ActionContext<ISettingsState, any>, users: UserInterface[]): void {
    store.commit("setUsers", users);
  },
  disconnectToken(store: ActionContext<ISettingsState, any>): void {
    TokenStorage.clear();
    store.commit("setUser", null);
    store.commit("setUsers", []);
  }
};
